import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fonts,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  root: {
    containerType: "inline-size",
    display: "flex",
    minHeight: 0,
    flex: 1,
    flexDirection: "column",
    gap: spacing.space16,
    color: colors.foreground,
    fontFamily: fonts.sans,
  },
  wide: {
    display: { default: "none", "@container (min-width: 480px)": "block" },
  },
  narrow: {
    display: { default: "block", "@container (min-width: 480px)": "none" },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "64px 64px minmax(0,1fr) 96px 120px",
    columnGap: spacing.space16,
    alignItems: "center",
  },
  header: {
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    paddingBlock: spacing.space6,
    color: colors.muted,
    fontSize: fontSizes.caption,
    fontWeight: 500,
  },
  row: {
    borderBottomWidth: { default: 1, ":last-child": 0 },
    borderBottomStyle: "solid",
    borderBottomColor: colors.border,
    paddingBlock: spacing.space8,
  },
  narrowRow: { display: "flex", flexDirection: "column", gap: spacing.space4 },
  line: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space8,
  },
  bottomLine: { justifyContent: "space-between" },
  id: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: fontSizes.small,
  },
  time: { fontSize: fontSizes.caption, color: colors.muted },
  score: {
    fontSize: fontSizes.label,
    lineHeight: "19px",
    fontWeight: 500,
    fontVariantNumeric: "tabular-nums",
  },
  end: { justifySelf: "end" },
  foot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing.space16,
    marginTop: "auto",
    fontSize: fontSizes.caption,
    lineHeight: "16px",
    color: colors.muted,
  },
  more: {
    color: colors.foreground,
    whiteSpace: "nowrap",
    textDecoration: { default: "none", ":hover": "underline" },
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 2,
  },
});
